import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import { withTranslation } from 'react-i18next'

import Button from 'srcReact/components/common2/Button'
import PasswordTextBox from 'srcReact/components/common2/PasswordTextBox'
import { isEmpty } from 'srcReact/helpers/validator'

import styles from './styles.module.scss'
import { isPasswordComplex } from 'srcReact/helpers/utils'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

const Password = ({
  checkResetKeyLoading,
  checkPasswordResetKey,
  passwordResetKey,
  resetKeyChecked,
  resetPasswordEmail,
  updatePassword,
  t
}) => {
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [passwordConfirmError, setPasswordConfirmError] = useState('')
  const { updatePasswordError } = useSelector((state) => state.authentication)

  useEffect(() => {
    checkPasswordResetKey(passwordResetKey)
  }, [])

  const validate = () => {
    setPasswordError('')
    setPasswordConfirmError('')
    if (isEmpty(password)) {
      setPasswordError(t('resetPasswordPage.passwordRequired'))
      return false
    }
    if (!isPasswordComplex(password)) {
      setPasswordError(t('resetPasswordPage.wrongFormat'))
      return false
    }
    if (isEmpty(passwordConfirmation)) {
      setPasswordConfirmError(t('resetPasswordPage.passwordRequired'))
      return false
    }
    if (password !== passwordConfirmation) {
      setPasswordConfirmError(t('resetPasswordPage.valuesNotTheSame'))
      return false
    }

    return true
  }

  if (checkResetKeyLoading) {
    return <div></div>
  }

  if (!resetKeyChecked) {
    return <div className={styles.container}>{t('resetPasswordPage.linkNotValid')}</div>
  }

  return (
    <div className={styles.container}>
      <div className={styles.containerTop}>
        <div>{t('resetPasswordPage.changePasswordFor')}</div>
        <div className={styles.email}>{resetPasswordEmail}</div>
      </div>
      <div className={styles.container1}>
        <PasswordTextBox
          label={t('resetPasswordPage.newPassword')}
          placeholder={t('resetPasswordPage.newPassword')}
          value={password}
          autoComplete='new-password'
          handleChange={(e) => setPassword(e.target.value)}
          direction='column'
          isRequired={true}
          errorMessage={passwordError}
        />
        <div className={styles.subtext}>{t('global.passwordSuggestion')}</div>
        <PasswordTextBox
          label={t('resetPasswordPage.retypePassword')}
          placeholder={t('resetPasswordPage.retypePassword')}
          value={passwordConfirmation}
          handleChange={(e) => setPasswordConfirmation(e.target.value)}
          onBlur={validate}
          direction='column'
          isRequired={true}
          errorMessage={passwordConfirmError}
        />
        {updatePasswordError && <ErrorMessage text={updatePasswordError} className={styles.error} />}
      </div>
      <div className={styles.buttonContainer}>
        <Button text={t('resetPasswordPage.back')} size='large' style='secondary' />
        <Button
          text={t('resetPasswordPage.confirm')}
          size='large'
          handleClick={() => {
            if (validate()) {
              updatePassword({
                reset_key: passwordResetKey,
                password
              })
            }
          }}
        />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const {
    authentication: { checkResetKeyLoading, resetKeyChecked, resetPasswordEmail }
  } = state
  return { checkResetKeyLoading, resetKeyChecked, resetPasswordEmail }
}

const actionCreators = {
  checkPasswordResetKey: authenticationActions.checkPasswordResetKey,
  updatePassword: authenticationActions.updatePassword
}

const ExtendedComponent = withTranslation('common')(Password)

const connectedPassword = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedPassword as Password }
